import Vue from 'vue';
import Vuex from 'vuex';
import app from '../app';

import menu from './modules/shared/menu';
import authUser from './modules/auth/user';
import chat from './modules/shared/chat';
import survey from './modules/shared/survey';
import theme from './modules/shared/theme';
import todo from './modules/shared/todo';


// HMS

import vendor from "./modules/ehms/vendor";
import facility from "./modules/ehms/facility";
import floor from "./modules/ehms/floor";
import unit from "./modules/ehms/unit";
import billing from "./modules/ehms/billing";
import signature from "./modules/ehms/signature/";
import signatureArchived from "./modules/ehms/signature/archived";
import signaturesApproval from "./modules/ehms/signature/signaturesApproval";
import signatureReport from "./modules/ehms/signature/report"
import client from "./modules/ehms/client";
import selectEhms from "./modules/ehms/select";
import file from "./modules/ehms/file";
import admission from "./modules/ehms/admission";
import inspection from "./modules/ehms/inspection";
import inspectionsDetail from "./modules/ehms/inspection/detail";
import inspectionsConcern from "./modules/ehms/inspection/concern";
import inspectionsCategory from "./modules/ehms/inspection/category";
import complaint from "./modules/ehms/complaint";
import incident from "./modules/ehms/incident";
import user from "./modules/ehms/user";
import role from "./modules/ehms/user/role";
import permission from "./modules/ehms/user/permission";

// INVENTORY

import product from "./modules/inventory/product/product";
import productUnit from "./modules/inventory/product/unit";
import model from "./modules/inventory/product/model";
import brand from "./modules/inventory/product/brand";
import category from "./modules/inventory/product/category";
import selectInventory from "./modules/inventory/select";
import supplier from "./modules/inventory/supplier";
import adjustment from "./modules/inventory/adjustment";
import requisition from "./modules/inventory/requisition";
import order from "./modules/inventory/purchase/order";
import received from "./modules/inventory/purchase/received"
import transfer from "./modules/inventory/purchase/transfer";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {},
    mutations: {
        changeLang(state, payload) {
            app.$i18n.locale = payload
            localStorage.setItem('currentLanguage', payload)
        }
    },
    actions: {
        setLang({commit}, payload) {
            commit('changeLang', payload)
        }
    },
    modules: {
        menu,
        authUser,
        chat,
        todo,
        survey,
        theme,

        // HMS

        vendor,
        facility,
        floor,
        unit,
        billing,
        signature,
        signaturesApproval,
        signatureArchived,
        signatureReport,
        client,
        selectEhms,
        file,
        admission,
        inspection,
        inspectionsDetail,
        inspectionsConcern,
        inspectionsCategory,
        complaint,
        incident,
        user,
        role,
        permission,

        // INVENTORY

        product,
        productUnit,
        model,
        brand,
        category,
        selectInventory,
        supplier,
        adjustment,
        requisition,
        order,
        received,
        transfer,
    }
})
